import { createContext } from 'react';

const ThemeContext = createContext('dark');


export default ThemeContext;
